import React from "react";
import "./Styles/starredCard.css"
import { priceFr } from "../Services/Numbers";
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { isProductInCart, getCart, setCart, addProductInCart, addProductInFavourites, getFavourites, isProductInFavourites } from '../Services/localStorage';
import { useState, useEffect } from 'react';

export default function StarredCard({ product = {} }) {
  const productsURL = process.env.REACT_APP_API_BASE_URL + '/images/products/';
  const [inCart, setInCart] = useState(false)

  useEffect(() => {
    setInCart(isProductInCart(product.id))
  })

  const addToCart = () => {
    addProductInCart(product, 1)
    setInCart(isProductInCart(product.id))
  }

  const goToProduct = (slug) => {
    window.location.href = "/boutique/"+slug;
  }

  let prices = '';
  let badge = '';
  
  if (product.discount) {
    let oldPrice = product.price;
    let newPrice = oldPrice - Math.round(oldPrice * product.discount / 100)
    prices = (<>
        <h3>{priceFr(newPrice)} F <span>{priceFr(oldPrice)} F</span></h3>
    </>)

    // badge = <span>-{product.discount}%</span>
    badge = "";
  }
  else {
    prices = (<>
      <h3>{priceFr(product.price)} F</h3>
    </>)
  }

  let stars = [];
  for (let i = 0; i < product.stars; i++) {
    stars.push(<StarIcon key={'full-star_' + product.slug + '_' + (i + 1)} sx={{ color: 'white', fontSize: '20px' }} />);
  }

  return (
    <div className="starred-card-container">
        {badge}
        <div onClick={()=>{goToProduct(product.slug)}} className="starred-card-img">
            <img src={productsURL+product.thumb} alt={product.thumb}/>
        </div>
        <p>
            {stars}
        </p>
        <h4>{product.name}</h4>
        {prices}
        {
          inCart ?
          <div className="already-in-cart"><p>Déjà dans le panier</p></div>
          :
          <button onClick={() => { addToCart() }}>Ajouter au panier</button>
        }
    </div>
  );
}